<template>
  <div class="view-right">
    <div class="view-list">
      <ViewItem
        v-for="(item, index) in list"
        :key="index"
        :index="index"
        :len="list.length"
        :isSource="true"
        :isShowBom="isShowBom"
        :data="item"
      />
    </div>
    <div v-if="list[0].tableBomData.length" class="all-toggle" @click="allToggle">
      {{ isShowBom ? '全部收起↑' : '全部展开↓' }}
    </div>
  </div>
</template>

<script>
import ViewItem from './view-item'
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  components: {
    ViewItem
  },
  data() {
    return {
      isShowBom: true
    }
  },
  methods: {
    allToggle() {
      this.isShowBom = !this.isShowBom
    }
  }
}
</script>

<style lang="less" scoped>
.view-right {
  position: relative;
  flex: 1;
  .view-list {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 10px;
    background: @colorWhite;
    border: @border;
    overflow-y: auto;
    .scroll-bar();
  }
  .all-toggle {
    position: absolute;
    right: 1px;
    top: 1px;
    padding: 5px 10px;
    color: @colorBlue;
    background: @colorBlue20;
    border-radius: 0 0 0 5px;
    cursor: pointer;
  }
}
</style>
